import React from 'react'
import "../articles.css"
import sunset from "../../../../assets/images/articles/sunset.jpg"
import { Byline, Published } from "../../"
import Demand from "../../../../assets/images/articles/Demand.jpeg"

export default function Article11Doc() {
  return (
    <div className='emas__articles'>
    <div className='emas__articles-container'>
        <img className="emas__articles-container_headImage" src={sunset} alt="sunset"/>
        <div className='emas__articles-container_photo'>
          <i >Photo by Pixabay: https://www.pexels.com/photo/sky-sunset-sun-twilight-46169/</i>
        </div>
        <h1>Operational Demand</h1>
        <div className='emas__articles-container_publish'>
          <p></p>
        </div>
        <div className='emas__articles-container_body'>
            <p>December 2023</p>
            <p>AEMO is forecasting a substantial increase in operational demand over the next 10 years. The following chart shows historical demand as well as our forecast using AEMO's assumptions. AEMO is expecting peak demand to hit 6,000 MW by 2032/33 (50% POE) - see Table 1 <a href='https://aemo.com.au/-/media/files/electricity/wem/planning_and_forecasting/esoo/2023/2023-wholesale-electricity-market-electricity-statement-of-opportunities-wem-esoo.pdf?la=en&hash=E05FBD7B0EEF023895B6360D590BAE26'>here</a>.  AEMO is forecasting minimum demand to fall to around 350 MW in 2027/28 before gradually increasing - see Figure 25 of the ESOO.</p>
            <p>The main driver of the growth in demand is electrification, including the uptake of electric vehicles. However, in the Gas Statement of Opportunities AEMO is expecting an increase in gas demand in the distribution sector (by households and businesses). That is, AEMO is expecting households and businesses will contribute to the increase in electricity demand mainly through their adoption of electric vehicles rather than their switching from gas to electricity. AEMO is assuming electrification will occur in the commercial and industrial sectors rather than in the distribution sector.</p>
            <p>Overall, while we consider AEMO's forecast of electric vehicle uptake is reasonable, we question whether their electrification assumption is overly optimistic. Our forecast of operational demand is available to premium clients (click <a href= 'Premarticle3' >here</a>).</p>
         </div>   
          <div className='emas__articles-container_photo'>
          <img className="emas__articles-container_headImage" src={Demand} alt="Demand"></img>
        </div>
        <Published />
    </div>
</div>
  )
}
